// import { changeMobile } from '../service/partnerCenter'
// const Wrapper = () => import('@/components/Wrapper')
// const Home = () => import('@/views/Index')

// 会员专区
// const VipList = () => import('@/views/member/List')
// const VipDetails = () => import('@/views/member/Details')

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/scrmMarket/index'),
    meta: {
      title: '活动'
    }
    // redirect: 'store-home'
    // redirect: 'sellCard'
    // redirect: 'scrmMarket'
  },
  // {
  //   path: '/store-home',
  //   name: 'store-home',
  //   component: Home,
  //   meta: {
  //     title: '酷开商城111',
  //     jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage']
  //   }
  // },
  {
    path: '/sellCard',
    name: 'sellCard',
    component: () => import('@/views/sellCard/Index'),
    meta: {
      title: '心动约惠七夕价'
    }
  },
  {
    path: '/secKillCard',
    name: 'secKillCard',
    component: () => import('@/views/seckillCard/index'),
    meta: {
      title: '公众号专属秒杀价'
    }
  },
  {
    path: '/scrmMarket',
    name: 'scrmMarket',
    component: () => import('@/views/scrmMarket/index'),
    meta: {
      title: '活动'
    }
  },
  {
    path: '/scrmPay',
    name: 'scrmPay',
    component: () => import('@/views/scrmMarket/PaySuccess'),
    meta: {
      title: '支付成功'
    }
  }
  // {
  //   path: '/member-region',
  //   name: 'member-region',
  //   component: Wrapper,
  //   children: [
  //     {
  //       name: 'vipList',
  //       path: 'list',
  //       component: VipList,
  //       meta: {
  //         title: '会员专区'
  //       }
  //     },
  //     {
  //       name: 'VipDetails',
  //       path: 'details',
  //       component: VipDetails,
  //       meta: {
  //         title: '会员卡'
  //       }
  //     }
  //   ]
  // },
]
export default routes
